import React, { useEffect, useState } from "react";
import { Keyboard, Clock } from "lucide-react";
import { Dialog } from "./VB";

const SHORTCUTS = [
  { key: "Alt + D", desc: "Dashboard" },
  { key: "Alt + K", desc: "Karyawan / Data" },
  { key: "Alt + A", desc: "Absensi" },
  { key: "Alt + I", desc: "Izin" },
  { key: "Alt + S", desc: "Shift" },
  { key: "Alt + P", desc: "Payroll / Slip Gaji" },
  { key: "Alt + L", desc: "Laporan" },
  { key: "Alt + H", desc: "Buka bantuan shortcut" },
  { key: "Esc", desc: "Tutup dialog" },
  { key: "F5", desc: "Refresh halaman" },
];

export default function Footer({ role }) {
  const [now, setNow] = useState(new Date());
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const map = role === "admin"
      ? { d: "/admin", k: "/admin/karyawan", a: "/admin/absensi", i: "/admin/izin", s: "/admin/shift", p: "/admin/payroll", l: "/admin/laporan" }
      : { d: "/karyawan", k: "/karyawan/profil", a: "/karyawan/absensi", i: "/karyawan/izin", s: "/karyawan/shift", p: "/karyawan/slip-gaji", l: "/karyawan/poin" };

    const handler = (e) => {
      if (e.altKey && !e.ctrlKey && !e.shiftKey) {
        const k = e.key.toLowerCase();
        if (k === "h") {
          e.preventDefault();
          setShowHelp(true);
          return;
        }
        if (map[k]) {
          e.preventDefault();
          window.location.href = map[k];
        }
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [role]);

  const pad = (n) => String(n).padStart(2, "0");
  const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
  const months = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
  const timeStr = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  const dateStr = `${days[now.getDay()]}, ${now.getDate()} ${months[now.getMonth()]} ${now.getFullYear()}`;

  return (
    <>
      <div
        style={{
          background: "linear-gradient(to bottom, #f0f0f0, #d4d4d4)",
          borderTop: "1px solid #828790",
          padding: "4px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: 11,
          color: "#333",
          fontFamily: "Segoe UI, Tahoma, sans-serif",
          flexWrap: "wrap",
          gap: 8,
        }}
        data-testid="app-footer"
      >
        <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
          <button
            className="vb-btn"
            onClick={() => setShowHelp(true)}
            style={{ padding: "2px 8px", fontSize: 11, display: "flex", alignItems: "center", gap: 4 }}
            data-testid="footer-shortcuts-btn"
          >
            <Keyboard className="w-3 h-3" /> Shortcut (Alt+H)
          </button>
          <span style={{ display: "flex", gap: 8, color: "#555" }}>
            <kbd style={kbdStyle}>Alt+D</kbd> Dashboard
            <kbd style={kbdStyle}>Alt+A</kbd> Absensi
            <kbd style={kbdStyle}>Alt+I</kbd> Izin
            <kbd style={kbdStyle}>Alt+P</kbd> Payroll
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 600 }} data-testid="footer-clock">
          <Clock className="w-3 h-3" />
          <span>{dateStr}</span>
          <span style={{ color: "#003399", fontFamily: "Consolas, monospace", fontSize: 12 }}>{timeStr}</span>
        </div>
      </div>

      <Dialog
        open={showHelp}
        onClose={() => setShowHelp(false)}
        title="Keyboard Shortcuts"
        width={420}
        footer={
          <button className="vb-btn" onClick={() => setShowHelp(false)} data-testid="close-help">Tutup</button>
        }
      >
        <table className="vb-table">
          <thead>
            <tr><th>Shortcut</th><th>Fungsi</th></tr>
          </thead>
          <tbody>
            {SHORTCUTS.map((s) => (
              <tr key={s.key}>
                <td><kbd style={{ ...kbdStyle, fontSize: 12 }}>{s.key}</kbd></td>
                <td>{s.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Dialog>
    </>
  );
}

const kbdStyle = {
  fontFamily: "Consolas, monospace",
  fontSize: 10,
  background: "white",
  border: "1px solid #999",
  borderRadius: 2,
  padding: "1px 5px",
  boxShadow: "0 1px 0 #999",
  color: "#000",
};
